const ru = {
  // Common
  common: {
    loading: 'Загрузка...',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    search: 'Поиск',
    filter: 'Фильтр',
    export: 'Экспорт',
    import: 'Импорт',
    back: 'Назад',
    next: 'Далее',
    previous: 'Предыдущий',
    submit: 'Отправить',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    yes: 'Да',
    no: 'Нет',
    or: 'или',
    and: 'и',
    all: 'Все',
    none: 'Нет',
    select: 'Выбрать',
    success: 'Успех',
    error: 'Ошибка',
    warning: 'Предупреждение',
    info: 'Информация',
    actions: 'Действия',
    status: 'Статус',
    active: 'Активный',
    inactive: 'Неактивный',
    enabled: 'Включено',
    disabled: 'Отключено',
    settings: 'Настройки',
    help: 'Помощь',
    logout: 'Выйти',
    login: 'Войти',
    signUp: 'Регистрация',
    email: 'Эл. почта',
    password: 'Пароль',
    username: 'Имя пользователя',
    name: 'Имя',
    phone: 'Телефон',
    address: 'Адрес',
    description: 'Описание',
    date: 'Дата',
    time: 'Время',
    total: 'Всего',
    amount: 'Сумма',
    price: 'Цена',
    quantity: 'Количество',
    download: 'Скачать',
    upload: 'Загрузить',
    refresh: 'Обновить',
    view: 'Просмотр',
    details: 'Подробности',
    more: 'Ещё',
    less: 'Меньше',
    new: 'НОВОЕ',
    testimonials: 'Отзывы',
    getStartedFree: 'Начать бесплатно',
    scheduleDemo: 'Запланировать демо',
    simpleProcess: 'Простой процесс',
    allRightsReserved: 'Все права защищены.',
  },

  // Navigation
  nav: {
    home: 'Главная',
    pricing: 'Цены',
    contact: 'Связаться с нами',
    integrations: 'Интеграции',
    docs: 'Документация',
    releases: 'Релизы',
    bookDemo: 'Заказать демо',
    bookAppointment: 'Записаться на встречу',
    solutions: 'Решения',
    getStarted: 'Начать',
    dashboard: 'Панель управления',
    voiceAgents: 'Голосовые агенты',
    campaigns: 'Кампании',
    analytics: 'Аналитика',
    users: 'Пользователи',
    settings: 'Настройки',
    billing: 'Биллинг',
    reports: 'Отчёты',
    leads: 'Лиды',
    files: 'Файлы',
    cloneVoice: 'Клонирование голоса',
    dialer: 'Автодозвон',
    dnc: 'Список DNC',
    agentMonitor: 'Мониторинг агентов',
  },

  // Home Page
  home: {
    heroTitle: 'Голосовые AI-агенты для вашего бизнеса',
    heroSubtitle: 'Автоматизируйте взаимодействие с клиентами с помощью интеллектуального голосового ИИ, который звучит естественно и ведёт сложные разговоры.',
    getStarted: 'Начать бесплатно',
    watchDemo: 'Смотреть демо',
    trustedBy: 'Нам доверяют ведущие компании',
    features: {
      title: 'Мощные возможности',
      subtitle: 'Всё необходимое для автоматизации голосовых коммуникаций',
      aiVoice: {
        title: 'Голосовые AI-агенты',
        description: 'Естественно звучащие AI-агенты, которые обрабатывают звонки 24/7 с человеческими разговорными способностями.',
      },
      autoDialer: {
        title: 'Автодозвон',
        description: 'Автоматизированные исходящие звонковые кампании с интеллектуальным управлением темпом и лидами.',
      },
      analytics: {
        title: 'Расширенная аналитика',
        description: 'Аналитика в реальном времени по производительности звонков, коэффициентам конверсии и эффективности агентов.',
      },
      integrations: {
        title: 'Бесшовные интеграции',
        description: 'Подключайтесь к CRM, календарю и другим инструментам для оптимизации рабочих процессов.',
      },
      voiceCloning: {
        title: 'Клонирование голоса',
        description: 'Создавайте уникальные AI-голоса, соответствующие идентичности и тону вашего бренда.',
      },
      multiLanguage: {
        title: 'Мультиязычная поддержка',
        description: 'Поддержка нескольких языков, включая английский, русский и узбекский.',
      },
    },
    cta: {
      title: 'Готовы трансформировать голосовые коммуникации?',
      subtitle: 'Начните бесплатный пробный период сегодня и увидите разницу, которую может сделать ИИ.',
      button: 'Начать бесплатно',
    },
  },

  // Auth
  auth: {
    login: 'Войти',
    signIn: 'Войти',
    signUp: 'Регистрация',
    logout: 'Выйти',
    forgotPassword: 'Забыли пароль?',
    resetPassword: 'Сбросить пароль',
    createAccount: 'Создать аккаунт',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    dontHaveAccount: 'Нет аккаунта?',
    emailPlaceholder: 'Введите ваш email',
    passwordPlaceholder: 'Введите ваш пароль',
    usernamePlaceholder: 'Введите имя пользователя',
    rememberMe: 'Запомнить меня',
    loginSuccess: 'Вход выполнен успешно!',
    loginError: 'Неверные данные. Попробуйте снова.',
    logoutSuccess: 'Вы вышли из системы.',
    welcomeBack: 'С возвращением!',
    signInToContinue: 'Войдите, чтобы продолжить работу с панелью управления',
    adminLogin: 'Вход администратора',
    clientLogin: 'Вход клиента',
    userLogin: 'Вход пользователя',
  },

  // Dashboard
  dashboard: {
    title: 'Панель управления',
    welcome: 'Добро пожаловать, {name}!',
    overview: 'Обзор',
    recentActivity: 'Последняя активность',
    quickActions: 'Быстрые действия',
    stats: {
      totalCalls: 'Всего звонков',
      answeredCalls: 'Отвечено',
      missedCalls: 'Пропущено',
      avgDuration: 'Ср. длительность',
      conversionRate: 'Конверсия',
      activeAgents: 'Активные агенты',
      activeCampaigns: 'Активные кампании',
      totalLeads: 'Всего лидов',
    },
  },

  // Voice Agents
  voiceAgents: {
    title: 'Голосовые агенты',
    createAgent: 'Создать агента',
    editAgent: 'Редактировать агента',
    deleteAgent: 'Удалить агента',
    agentName: 'Имя агента',
    agentVoice: 'Голос',
    agentLanguage: 'Язык',
    agentScript: 'Скрипт',
    agentStatus: 'Статус',
    testAgent: 'Тестировать агента',
    testWithChat: 'Тест в чате',
    testWithWeb: 'Веб-звонок',
    testWithPhone: 'Телефонный звонок',
    voiceProvider: 'Провайдер голоса',
    voicePreview: 'Прослушать голос',
    welcomeMessage: 'Приветственное сообщение',
    conversationalFlow: 'Сценарий разговора',
    transferSettings: 'Настройки переадресации',
    enableTransfer: 'Включить переадресацию',
    transferNumber: 'Номер для переадресации',
    noAgents: 'Голосовых агентов пока нет. Создайте первого агента, чтобы начать.',
  },

  // Campaigns
  campaigns: {
    title: 'Кампании',
    createCampaign: 'Создать кампанию',
    editCampaign: 'Редактировать кампанию',
    deleteCampaign: 'Удалить кампанию',
    campaignName: 'Название кампании',
    campaignStatus: 'Статус',
    campaignType: 'Тип',
    startCampaign: 'Запустить кампанию',
    pauseCampaign: 'Приостановить кампанию',
    stopCampaign: 'Остановить кампанию',
    contacts: 'Контакты',
    dialed: 'Набрано',
    answered: 'Отвечено',
    noAnswer: 'Нет ответа',
    busy: 'Занято',
    failed: 'Не удалось',
    transferred: 'Переадресовано',
    completed: 'Завершено',
    progress: 'Прогресс',
    uploadContacts: 'Загрузить контакты',
    selectAgent: 'Выбрать голосового агента',
    dialDelay: 'Задержка набора (сек)',
    maxConcurrent: 'Макс. одновременных звонков',
    noCampaigns: 'Кампаний пока нет. Создайте первую кампанию для начала обзвона.',
    health: 'Состояние кампании',
  },

  // Analytics
  analytics: {
    title: 'Аналитика',
    overview: 'Обзор',
    callAnalytics: 'Аналитика звонков',
    voiceAnalytics: 'Голосовая аналитика',
    performanceMetrics: 'Показатели эффективности',
    dateRange: 'Период',
    today: 'Сегодня',
    yesterday: 'Вчера',
    last7Days: 'Последние 7 дней',
    last30Days: 'Последние 30 дней',
    thisMonth: 'Этот месяц',
    lastMonth: 'Прошлый месяц',
    custom: 'Произвольный период',
    exportReport: 'Экспорт отчёта',
    callVolume: 'Объём звонков',
    successRate: 'Успешность',
    avgCallDuration: 'Ср. длительность звонка',
    peakHours: 'Пиковые часы',
  },

  // Users
  users: {
    title: 'Пользователи',
    createUser: 'Создать пользователя',
    editUser: 'Редактировать пользователя',
    deleteUser: 'Удалить пользователя',
    userName: 'Имя пользователя',
    userEmail: 'Email',
    userRole: 'Роль',
    userStatus: 'Статус',
    lastLogin: 'Последний вход',
    assignedPhone: 'Назначенный телефон',
    availability: 'Доступность',
    available: 'Доступен',
    busy: 'Занят',
    offline: 'Офлайн',
    noUsers: 'Пользователей пока нет. Добавьте первого пользователя.',
  },

  // Settings
  settings: {
    title: 'Настройки',
    general: 'Основные',
    account: 'Аккаунт',
    notifications: 'Уведомления',
    security: 'Безопасность',
    integrations: 'Интеграции',
    billing: 'Биллинг',
    api: 'API',
    timezone: 'Часовой пояс',
    language: 'Язык',
    theme: 'Тема',
    darkMode: 'Тёмная тема',
    lightMode: 'Светлая тема',
    saveChanges: 'Сохранить изменения',
    changePassword: 'Сменить пароль',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите пароль',
  },

  // Integrations
  integrations: {
    title: 'Интеграции',
    subtitle: 'Подключайтесь к вашим любимым инструментам и платформам',
    ecosystem: 'Экосистема',
    connected: 'Подключено',
    notConnected: 'Не подключено',
    connect: 'Подключить',
    disconnect: 'Отключить',
    configure: 'Настроить',
    testConnection: 'Проверить подключение',
    apiKey: 'API ключ',
    apiSecret: 'API секрет',
    webhookUrl: 'URL вебхука',
    categories: {
      crm: 'CRM',
      calendar: 'Календарь',
      messaging: 'Сообщения',
      analytics: 'Аналитика',
      contactCenter: 'Контакт-центр',
      other: 'Другое',
    },
  },

  // Billing
  billing: {
    title: 'Биллинг',
    currentPlan: 'Текущий тариф',
    usage: 'Использование',
    invoices: 'Счета',
    paymentMethods: 'Способы оплаты',
    upgradePlan: 'Улучшить тариф',
    cancelSubscription: 'Отменить подписку',
    billingHistory: 'История платежей',
    nextBillingDate: 'Следующий платёж',
    minutesUsed: 'Использовано минут',
    minutesRemaining: 'Осталось минут',
  },

  // Leads
  leads: {
    title: 'Лиды',
    createLead: 'Создать лид',
    importLeads: 'Импорт лидов',
    exportLeads: 'Экспорт лидов',
    leadName: 'Имя лида',
    leadPhone: 'Телефон',
    leadEmail: 'Email',
    leadStatus: 'Статус',
    leadSource: 'Источник',
    new: 'Новый',
    contacted: 'Связались',
    qualified: 'Квалифицирован',
    converted: 'Конвертирован',
    lost: 'Потерян',
    noLeads: 'Лидов пока нет. Импортируйте или создайте лиды.',
  },

  // Files
  files: {
    title: 'Файлы',
    uploadFile: 'Загрузить файл',
    deleteFile: 'Удалить файл',
    fileName: 'Имя файла',
    fileSize: 'Размер',
    fileType: 'Тип',
    uploadedAt: 'Загружен',
    noFiles: 'Файлы ещё не загружены.',
    dragDrop: 'Перетащите файлы сюда или нажмите для выбора',
    supportedFormats: 'Поддерживаемые форматы: CSV, XLS, XLSX',
  },

  // Errors
  errors: {
    somethingWentWrong: 'Что-то пошло не так. Попробуйте снова.',
    pageNotFound: 'Страница не найдена',
    unauthorized: 'У вас нет доступа к этой странице.',
    sessionExpired: 'Сессия истекла. Войдите снова.',
    networkError: 'Ошибка сети. Проверьте подключение.',
    validationError: 'Проверьте введённые данные.',
    serverError: 'Ошибка сервера. Попробуйте позже.',
  },

  // Success Messages
  success: {
    saved: 'Изменения сохранены!',
    created: 'Успешно создано!',
    updated: 'Успешно обновлено!',
    deleted: 'Успешно удалено!',
    uploaded: 'Файл загружен!',
    imported: 'Данные импортированы!',
    exported: 'Данные экспортированы!',
    copied: 'Скопировано в буфер!',
  },

  // Confirmation
  confirm: {
    delete: 'Вы уверены, что хотите удалить это?',
    cancel: 'Вы уверены, что хотите отменить?',
    logout: 'Вы уверены, что хотите выйти?',
    discard: 'Отменить несохранённые изменения?',
  },

  // Footer
  footer: {
    copyright: '© {year} AIConneqtors. Все права защищены.',
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
    contact: 'Связаться с нами',
    about: 'О нас',
    description: 'Создавайте, тестируйте и запускайте разговорные ИИ-системы с помощью no-code инструментов и API.',
    product: 'Продукт',
    features: 'Функции',
    resources: 'Ресурсы',
    apiReference: 'API документация',
    blog: 'Блог',
    helpCenter: 'Центр помощи',
    company: 'Компания',
    cookies: 'Cookies',
  },

  // Language Selector
  languageSelector: {
    title: 'Выберите язык',
    current: 'Текущий язык',
  },

  // Header
  header: {
    announcement: 'Теперь вы можете покупать телефонные номера в AIConneqtors!',
    viewUpdate: 'Подробнее',
    admin: 'Админ',
  },

  // Hero Section
  hero: {
    title: 'Создайте своего',
    free: 'Бесплатного',
    voiceAI: 'Голосового ИИ',
    assistant: 'Ассистента',
    subtitle: 'Создавайте, тестируйте и запускайте надёжных голосовых ИИ-ассистентов',
    placeholder: 'Опишите вашего идеального голосового ИИ-ассистента',
    guidedFlow: 'Пошаговое создание',
    createAgent: 'Создать агента',
    chooseUseCase: 'Выберите сценарий использования',
    useCases: ['Генерация лидов', 'Записи', 'Поддержка', 'Переговоры', 'Сборы']
  },

  // Core Capabilities
  capabilities: {
    title: 'Ключевые возможности',
    heading: 'Почему AIConneqtors для',
    voiceAI: 'Голосового ИИ',
    subtitle: 'Мощные функции для создания, развёртывания и масштабирования голосовых ИИ-ассистентов',
    selectLanguage: 'Выберите язык',
    features: [
      {
        icon: 'Languages',
        title: 'Многоязычность',
        description: 'Обслуживайте пользователей на 50+ языках по всему миру'
      },
      {
        icon: 'ArrowUpRight',
        title: 'Масштаб исходящих',
        description: 'Автоматизируйте генерацию лидов, напоминания и сборы'
      },
      {
        icon: 'Clock',
        title: '24/7 Входящие',
        description: 'Обрабатывайте бронирования и запросы круглосуточно'
      },
      {
        icon: 'Plug',
        title: 'Интеграции',
        description: 'Интегрируйтесь с CRM, Sheets, Slack, n8n'
      },
      {
        icon: 'GraduationCap',
        title: 'Быстрое обучение',
        description: 'Обучайте ИИ с помощью ваших записей звонков'
      },
      {
        icon: 'Phone',
        title: 'Телефонные номера',
        description: 'Покупайте номера США (+1) мгновенно'
      }
    ]
  },

  // User Dashboard
  userDashboard: {
    title: 'Портал агента',
    welcome: 'С возвращением',
    welcomeSubtitle: 'Принимайте и управляйте переадресованными звонками от ИИ-агентов',
    softphoneSetup: 'Настройка софтфона (Zoiper/Linphone)',
    yourPhone: 'Ваш телефон',
    notAssigned: 'Не назначен',
    downloadZoiper: 'Скачать Zoiper',
    sipDescription: 'Используйте эти SIP-данные для настройки Zoiper, Linphone или любого SIP-совместимого софтфона для приёма переадресованных звонков.',
    sipServer: 'SIP Сервер / Домен',
    username: 'Имя пользователя / SIP ID',
    password: 'Пароль',
    outboundProxy: 'Исходящий прокси (опционально)',
    setupInstructions: 'Инструкции по настройке',
    callsWillBeTransferred: 'Звонки будут переадресованы на ваш софтфон, когда ИИ определит намерение переключения',
    availability: 'Доступность',
    available: 'Доступен',
    busy: 'Занят',
    callsToday: 'Звонков сегодня',
    minutesUsed: 'Минут использовано',
    plan: 'Тариф',
    voiceAgents: 'Ваши голосовые ИИ-агенты',
    noAgentsAssigned: 'Агенты не назначены',
    contactAdmin: 'Свяжитесь с администратором для назначения агентов вашему аккаунту',
    testCall: 'Тестовый звонок',
    recentCalls: 'Последние звонки',
    upgradePlan: 'Улучшить тариф',
    moreMinutes: 'Получите больше минут и откройте премиум-функции',
    viewAllPlans: 'Все тарифы',
    lowMinutes: 'Мало минут! Осталось только',
    minRemaining: 'мин',
    upgrade: 'Улучшить',
    demoMode: 'Демо-режим',
    callsSimulated: 'Звонки симулируются. Для реальных звонков нужен API-ключ Telnyx.',
    phoneToCall: 'Номер для звонка',
  },

  // Desktop Notifications
  notifications: {
    enableTitle: 'Включить уведомления',
    enableDescription: 'Получайте оповещения о входящих звонках, даже когда эта вкладка в фоне',
    enable: 'Включить',
    incomingCall: 'Входящий звонок',
    callFrom: 'Звонок от',
    clickToAnswer: 'Нажмите, чтобы ответить',
  },

  // Zoiper Setup Steps
  zoiperSetup: {
    download: 'Скачайте и установите Zoiper с',
    openZoiper: 'Откройте Zoiper и нажмите "Create Account" → "Yes" (I have credentials)',
    enterCredentials: 'Введите имя пользователя и пароль, указанные выше',
    forProvider: 'В поле Provider введите:',
    skipOptional: 'Пропустите необязательные настройки и нажмите "Create"',
    waitReady: 'Дождитесь статуса "Ready" или зелёного индикатора',
    keepRunning: 'Держите Zoiper запущенным для приёма входящих звонков',
  },

  // Linphone Setup Steps
  linphoneSetup: {
    download: 'Скачайте Linphone с',
    goToSettings: 'Перейдите в Settings → Account → Add Account',
    selectSIP: 'Выберите "I have a SIP account"',
    enterDetails: 'Введите имя пользователя, пароль и домен (sip.telnyx.com)',
    saveWait: 'Сохраните и дождитесь регистрации',
  },

  // Sidebar
  sidebar: {
    clientPortal: 'Портал клиента',
    client: 'Клиент',
    clientAdmin: 'Администратор клиента',
    plan: 'Тариф',
    voiceAiSetup: 'НАСТРОЙКА ГОЛОСОВОГО ИИ',
    operationsMonitoring: 'ОПЕРАЦИИ И МОНИТОРИНГ',
    monitoring: 'МОНИТОРИНГ',
    management: 'УПРАВЛЕНИЕ',
    accountBilling: 'АККАУНТ И БИЛЛИНГ',
    phoneNumbers: 'Телефонные номера',
    callLogs: 'История звонков',
    campaignHealth: 'Состояние кампаний',
    voiceAnalytics: 'Голосовая аналитика',
    usageQuotas: 'Использование и квоты',
    dialerPortal: 'Портал дозвона',
    restrictedFeatures: 'Некоторые функции могут быть ограничены',
    telnyxSettings: 'Настройки Telnyx',
  },

  // Client Dashboard
  clientDashboard: {
    totalUsers: 'Всего пользователей',
    activeAgents: 'Активные агенты',
    totalCalls: 'Всего звонков',
    subtitle: 'Управляйте пользователями и голосовыми ИИ-агентами из этой панели',
    recentAgents: 'Последние голосовые агенты',
    noAgentsYet: 'Агентов пока нет. Создайте первого голосового агента.',
    createAgentDesc: 'Настройте нового голосового ИИ-ассистента',
    manageUsers: 'Управление пользователями',
    manageUsersDesc: 'Добавьте или редактируйте участников команды',
  },

  // Voice Agents Page
  voiceAgents: {
    title: 'Голосовые ИИ агенты',
    subtitle: 'Создавайте и управляйте голосовыми ИИ-ассистентами',
    createAgent: 'Создать агента',
    refresh: 'Обновить',
    agentQuota: 'Квота агентов',
    noSlotsRemaining: 'Слоты закончились. Обратитесь к администратору для обновления.',
    slotsRemaining: 'слот(ов) осталось',
    searchPlaceholder: 'Поиск агентов по имени или языку...',
    noAgentsFound: 'Агенты не найдены. Нажмите "Создать агента" для начала.',
    loadingAgents: 'Загрузка агентов...',
    editAgent: 'Редактировать агента',
    viewScript: 'Просмотр скрипта',
    deleteAgent: 'Удалить агента',
    confirmDelete: 'Вы уверены, что хотите удалить этого агента?',
    agentDeleted: 'Агент успешно удалён',
    agentCreated: 'Агент успешно создан',
    agentUpdated: 'Агент успешно обновлён',
    limitReached: 'Достигнут лимит агентов. Обратитесь к администратору для обновления.',
    calls: 'звонков',
    status: 'Статус',
    language: 'Язык',
    voice: 'Голос',
    script: 'Скрипт',
    greeting: 'Приветствие',
    description: 'Описание',
    name: 'Название',
    advancedSettings: 'Расширенные настройки',
    fullEditor: 'Полный редактор',
  },

  // Campaigns Page
  campaigns: {
    title: 'Авто-дозвон кампании',
    subtitle: 'Загрузите списки контактов и автоматически набирайте номера с ИИ-агентами',
    newCampaign: 'Новая кампания',
    createCampaign: 'Создать кампанию',
    noCampaigns: 'Нет кампаний',
    createFirstCampaign: 'Создайте первую кампанию авто-дозвона для начала',
    contacts: 'контактов',
    agent: 'Агент',
    delay: 'задержка',
    scheduled: 'Запланировано',
    daily: 'Ежедневно',
    weekly: 'Еженедельно',
    monthly: 'Ежемесячно',
    nextRun: 'Далее',
    runs: 'запусков',
    progress: 'Прогресс',
    viewDetails: 'Подробнее',
    start: 'Старт',
    pause: 'Пауза',
    stop: 'Стоп',
    delete: 'Удалить',
    confirmDelete: 'Вы уверены, что хотите удалить эту кампанию?',
    noDescription: 'Без описания',
    filterAll: 'Все',
    filterDraft: 'Черновик',
    filterScheduled: 'Запланировано',
    filterRunning: 'Активно',
    filterPaused: 'Приостановлено',
    filterStopped: 'Остановлено',
    filterCompleted: 'Завершено',
    filterCancelled: 'Отменено',
  },

  // Analytics Page
  analytics: {
    title: 'Панель аналитики',
    subtitle: 'Метрики звонков и показатели эффективности',
    lastDays: 'Последние {days} дней',
    last7Days: 'Последние 7 дней',
    last14Days: 'Последние 14 дней',
    last30Days: 'Последние 30 дней',
    last90Days: 'Последние 90 дней',
    totalCalls: 'Всего звонков',
    answered: 'Отвечено',
    avgDuration: 'Средняя длительность',
    talkTime: 'Время разговора',
    outbound: 'Исходящие',
    inbound: 'Входящие',
    answeredCalls: 'Отвеченные звонки',
    answerRate: 'Процент ответов',
    peakHour: 'Пиковый час',
    callOutcomes: 'Результаты звонков',
    noAnswer: 'Без ответа',
    busy: 'Занято',
    failed: 'Неудачно',
    durationDistribution: 'Распределение по длительности',
    under1Min: 'До 1 мин',
    oneToFiveMins: '1-5 мин',
    fiveToTenMins: '5-10 мин',
    overTenMins: '10+ мин',
    campaignPerformance: 'Эффективность кампаний',
    noCampaigns: 'Кампании не найдены',
    recentCallsWithRecordings: 'Последние звонки с записями',
    noCallsFound: 'Звонки с записями не найдены',
    playRecording: 'Воспроизвести запись',
    viewTranscript: 'Просмотр транскрипции',
    loading: 'Загрузка аналитики...',
    retry: 'Повторить',
    failedToLoad: 'Не удалось загрузить данные аналитики',
  },

  // Telnyx Settings
  telnyxSettings: {
    title: 'Настройки Telnyx',
    subtitle: 'Используйте свой аккаунт Telnyx для звонков и раздельного биллинга',
    configTitle: 'Ваши учётные данные Telnyx',
    callerID: 'Номер звонящего',
    enableOwn: 'Использовать свой аккаунт Telnyx',
    enableDesc: 'При включении кампании будут использовать ваши учётные данные Telnyx вместо системных',
    apiKey: 'API ключ',
    apiKeyPlaceholder: 'Введите ваш API ключ Telnyx',
    apiKeyRequired: 'API ключ обязателен',
    apiKeyHelp: 'Получите API ключ на',
    connectionId: 'ID подключения (Call Control App)',
    connectionIdPlaceholder: 'Введите ID вашего Call Control Application',
    connectionIdHelp: 'ID вашего приложения Call Control в Telnyx',
    phoneNumber: 'Номер телефона',
    phoneNumberHelp: 'Исходящий номер для идентификации из вашего аккаунта Telnyx',
    verified: 'Подтверждено',
    notVerified: 'Не подтверждено',
    verify: 'Проверить данные',
    useSystem: 'Использовать системные',
    saveSuccess: 'Конфигурация Telnyx успешно сохранена',
    saveError: 'Не удалось сохранить конфигурацию',
    verifySuccess: 'Учётные данные успешно подтверждены',
    verifyFailed: 'Проверка учётных данных не удалась',
    verifyError: 'Ошибка проверки учётных данных',
    deleteSuccess: 'Конфигурация удалена. Используются системные настройки.',
    deleteError: 'Не удалось удалить конфигурацию',
    confirmDelete: 'Вы уверены, что хотите удалить конфигурацию Telnyx и использовать системные настройки?',
    helpTitle: 'Как это работает',
    help1: '1. Введите ваш API ключ Telnyx, ID подключения и номер телефона',
    help2: '2. Нажмите "Сохранить" для безопасного хранения учётных данных',
    help3: '3. Все ваши кампании теперь будут использовать ваш аккаунт Telnyx для биллинга',
  },

  // Voice Analytics Dashboard
  voiceAnalytics: {
    title: 'Голосовая аналитика',
    subtitle: 'Расширенный анализ звонков и инсайты',
    exportPdf: 'Экспорт PDF',
    tabOverview: 'Обзор',
    tabTalkTime: 'Время разговора',
    tabKeywords: 'Ключевые слова',
    tabOutcomes: 'Результаты',
    tabAiInsights: 'ИИ инсайты',
    tabPerformance: 'Эффективность',
    tabCompare: 'Сравнение',
    totalCalls: 'Всего звонков',
    talkTime: 'Время разговора',
    answerRate: 'Процент ответов',
    transferRate: 'Процент переводов',
    hourlyDistribution: 'Почасовое распределение звонков',
    durationDistribution: 'Распределение по длительности',
    dailyTrends: 'Ежедневные тренды',
    peakAnalysis: 'Анализ пиков',
    peakHour: 'Пиковый час',
    peakDay: 'Пиковый день',
    callsAtPeak: 'звонков',
    avgDuration: 'Средняя длительность',
    minDuration: 'Мин. длительность',
    maxDuration: 'Макс. длительность',
    topKeywords: 'Топ ключевых слов',
    keywordsOverall: 'Общие',
    keywordsCustomer: 'От клиентов',
    keywordsAgent: 'От агентов',
    phraseAnalysis: 'Анализ фраз',
    transferRequests: 'Запросы на перевод',
    positiveSentiment: 'Позитивный настрой',
    negativeSentiment: 'Негативный настрой',
    outcomeDistribution: 'Распределение результатов',
    statusDistribution: 'Распределение статусов',
    agentPerformance: 'Эффективность агентов',
    conversionFunnel: 'Воронка конверсии',
    dialed: 'Набрано',
    answered: 'Отвечено',
    completed: 'Завершено',
    customerSatisfaction: 'Удовлетворённость клиентов',
    topIntent: 'Топ намерение',
    objectionRate: 'Процент возражений',
    intentTrends: 'Тренды намерений',
    topObjections: 'Топ возражений',
    noDataAvailable: 'Нет данных',
    noDataMessage: 'ИИ инсайты появятся здесь, когда у вас будут данные о звонках.',
    bestTimeSlots: 'Лучшее время для звонков',
    performanceByLanguage: 'Эффективность по языкам',
    calls: 'звонков',
    successRate: 'процент успеха',
  },

  // FAQ Section
  faq: {
    title: 'Часто задаваемые вопросы',
    subtitle: 'Общие вопросы о платформе AIConneqtors',
    questions: [
      {
        question: 'Как быстро я могу создать голосового ИИ-агента?',
        answer: 'Вы можете создать полнофункционального голосового ИИ-агента на AIConneqtors менее чем за 5 минут. Просто опишите, выберите голос и запустите. Программирование не требуется.'
      },
      {
        question: 'Нужны ли мне технические знания или навыки программирования?',
        answer: 'Совсем нет. AIConneqtors создан для всех - от владельцев бизнеса до разработчиков. Вы можете создавать, тестировать и развёртывать ИИ-агентов без написания единой строки кода.'
      },
      {
        question: 'Какие голосовые ИИ-агенты я могу создать?',
        answer: 'На AIConneqtors вы можете создать ботов поддержки клиентов, агентов генерации лидов, планировщиков встреч, помощников по продажам, системы IVR и многое другое.'
      },
      {
        question: 'Могу ли я настроить то, как звучит и отвечает ИИ-агент?',
        answer: 'Безусловно. AIConneqtors позволяет выбирать из множества естественных голосов, тонов, скоростей речи и эмоциональных стилей.'
      },
      {
        question: 'Что происходит после создания агента?',
        answer: 'После создания на AIConneqtors вы можете мгновенно протестировать агента, развернуть его на звонках или на сайте и отслеживать аналитику в реальном времени.'
      },
      {
        question: 'Есть ли бесплатная пробная версия или демо?',
        answer: 'Да. Вы можете зарегистрироваться для бесплатной пробной версии на AIConneqtors, чтобы создать своего первого агента и испытать платформу.'
      },
    ]
  },

  // How It Works Section
  howItWorks: {
    title: 'Как это работает',
    subtitle: 'Начните работу с AIConneqtors за три простых шага',
    stepButtons: [
      { step: 1, icon: 'PenLine', title: 'Напишите', description: 'Опишите, какого голосового ИИ-ассистента вы хотите' },
      { step: 2, icon: 'FlaskConical', title: 'Тестируйте', description: 'Попробуйте ассистента и посмотрите, как он работает' },
      { step: 3, icon: 'Puzzle', title: 'Добавьте функции', description: 'Улучшайте через чат и drag-and-drop' },
      { step: 4, icon: 'Rocket', title: 'Развёртывание', description: 'Сделайте ассистента доступным для пользователей' },
      { step: 5, icon: 'LineChart', title: 'Наблюдение', description: 'Отслеживайте производительность и улучшайте' }
    ],
    steps: [
      {
        number: '01',
        title: 'Создайте агента',
        description: 'Опишите идеального ИИ-помощника на естественном языке. Выберите голос, личность и поведение.'
      },
      {
        number: '02',
        title: 'Настройте и протестируйте',
        description: 'Настройте сценарии звонков, интеграции и протестируйте агента в реальных разговорах перед запуском.'
      },
      {
        number: '03',
        title: 'Запустите и масштабируйте',
        description: 'Запустите агента мгновенно. Обрабатывайте тысячи звонков одновременно с полной аналитикой.'
      }
    ],
    stepDetails: {
      1: {
        title: 'Создавайте голосовых ИИ-ассистентов на естественном языке',
        subtitle: 'Просто опишите, что должен делать ваш голосовой ИИ-ассистент, и мы создадим его для вас.',
        features: [
          {
            icon: 'MessageCircle',
            title: 'Разговорное создание',
            description: 'Создавайте ассистента через естественный диалог — просто общайтесь с платформой о том, что вам нужно.'
          },
          {
            icon: 'MousePointerSquare',
            title: 'Drag-and-Drop интерфейс',
            description: 'Настраивайте возможности ассистента с помощью интуитивного редактора перетаскивания.'
          },
          {
            icon: 'FileText',
            title: 'Готовые шаблоны',
            description: 'Начните с отраслевых шаблонов и настройте под свои потребности.'
          }
        ]
      },
      2: {
        title: 'Тестируйте вашего голосового ИИ-ассистента',
        subtitle: 'Просматривайте и тестируйте ассистента в реальном времени перед развёртыванием.',
        features: [
          {
            icon: 'Mic',
            title: 'Тестирование голосом',
            description: 'Тестируйте ассистента реальными голосовыми командами и слушайте ответы в реальном времени.'
          },
          {
            icon: 'MessageSquare',
            title: 'Симуляция разговора',
            description: 'Симулируйте полные разговоры, чтобы обеспечить естественный поток и точные ответы.'
          },
          {
            icon: 'ClipboardCheck',
            title: 'Контроль качества',
            description: 'Запускайте автоматические тесты, чтобы убедиться, что ассистент правильно обрабатывает крайние случаи.'
          }
        ]
      },
      3: {
        title: 'Интегрируйте с вашими системами',
        subtitle: 'Подключите вашего голосового ИИ-ассистента к существующим инструментам и рабочим процессам.',
        features: [
          {
            icon: 'Zap',
            title: 'API интеграция',
            description: 'Подключайтесь к любой системе с помощью нашего комплексного REST API и вебхуков.'
          },
          {
            icon: 'Database',
            title: 'Синхронизация с CRM',
            description: 'Автоматически синхронизируйте данные звонков и информацию о клиентах с вашей CRM.'
          },
          {
            icon: 'GitBranch',
            title: 'Автоматизация процессов',
            description: 'Запускайте действия в других приложениях на основе результатов разговора.'
          }
        ]
      },
      4: {
        title: 'Развёртывание и масштабирование',
        subtitle: 'Запустите ассистента и обрабатывайте тысячи одновременных звонков.',
        features: [
          {
            icon: 'Phone',
            title: 'Настройка номеров',
            description: 'Получите выделенные телефонные номера или мгновенно подключите существующие.'
          },
          {
            icon: 'Globe',
            title: 'Глобальное развёртывание',
            description: 'Развёртывайте в нескольких регионах для низкой задержки звонков по всему миру.'
          },
          {
            icon: 'Share2',
            title: 'Многоканальная поддержка',
            description: 'Расширьте ассистента на веб, мобильные и мессенджер-платформы.'
          }
        ]
      },
      5: {
        title: 'Мониторинг и оптимизация',
        subtitle: 'Отслеживайте производительность и постоянно улучшайте вашего голосового ИИ-ассистента.',
        features: [
          {
            icon: 'BarChart2',
            title: 'Аналитика в реальном времени',
            description: 'Отслеживайте объёмы звонков, показатели успеха и удовлетворённость клиентов в реальном времени.'
          },
          {
            icon: 'FileSearch',
            title: 'Анализ разговоров',
            description: 'Анализируйте транскрипты, чтобы понять потребности клиентов и улучшить ответы.'
          },
          {
            icon: 'TrendingUp',
            title: 'Обучение ИИ',
            description: 'Ваш ассистент постоянно совершенствуется на основе реальных разговоров.'
          }
        ]
      }
    }
  },

  // Key Features Section
  keyFeatures: {
    title: 'Ключевые возможности',
    subtitle: 'Всё необходимое для создания мощных голосовых ИИ-решений',
    features: [
      {
        title: 'Естественный синтез речи',
        description: 'Ультрареалистичные голоса ИИ, которые звучат как люди, с настраиваемым тоном, скоростью и эмоциями.'
      },
      {
        title: 'Умная маршрутизация звонков',
        description: 'Интеллектуальная маршрутизация на основе намерений, настроения и истории клиента.'
      },
      {
        title: 'Аналитика в реальном времени',
        description: 'Живые панели, отслеживающие метрики звонков, конверсию и эффективность агентов.'
      },
      {
        title: 'Интеграция с CRM',
        description: 'Бесшовное подключение к существующим инструментам - Salesforce, HubSpot и другим.'
      },
      {
        title: 'Многоязычная поддержка',
        description: 'ИИ-агенты, которые говорят и понимают несколько языков свободно.'
      },
      {
        title: 'Запись и транскрипция звонков',
        description: 'Автоматическая запись и транскрипция каждого разговора для обучения и соответствия требованиям.'
      }
    ]
  },

  // Testimonials Section
  testimonials: {
    title: 'Что говорят наши клиенты',
    subtitle: 'Нам доверяют компании по всему миру',
    items: [
      {
        quote: 'AIConneqtors преобразил наше обслуживание клиентов. Мы обрабатываем в 3 раза больше звонков с лучшими показателями удовлетворённости.',
        author: 'Сара Джонсон',
        role: 'Вице-президент по работе с клиентами',
        company: 'TechCorp Inc.'
      },
      {
        quote: 'Настройка нашего ИИ-агента заняла минуты, а не недели. Окупаемость была мгновенной.',
        author: 'Михаил Чен',
        role: 'Директор по операциям',
        company: 'GlobalRetail'
      },
      {
        quote: 'Качество голоса невероятное. Наши клиенты часто не могут понять, что разговаривают с ИИ.',
        author: 'Эмили Родригес',
        role: 'Генеральный директор',
        company: 'StartupXYZ'
      }
    ]
  },

  // Pricing Page
  pricing: {
    title: 'Простые и прозрачные цены',
    subtitle: 'Выберите план, который подходит вашему бизнесу',
    monthly: 'Ежемесячно',
    yearly: 'Ежегодно',
    save: 'Экономия 20%',
    perMonth: '/месяц',
    perYear: '/год',
    getStarted: 'Начать',
    contactSales: 'Связаться с отделом продаж',
    mostPopular: 'Самый популярный',
    features: 'Возможности',
    plans: {
      starter: {
        name: 'Стартовый',
        price: '$49',
        description: 'Идеально для малого бизнеса',
        features: [
          '1 голосовой ИИ-агент',
          '500 минут/месяц',
          'Базовая аналитика',
          'Поддержка по email',
          'Стандартные голоса'
        ]
      },
      professional: {
        name: 'Профессиональный',
        price: '$149',
        description: 'Для растущего бизнеса с большим объёмом',
        features: [
          '5 голосовых ИИ-агентов',
          '2,500 минут/месяц',
          'Расширенная аналитика',
          'Приоритетная поддержка',
          'Премиум голоса',
          'Интеграции с CRM',
          'Запись звонков'
        ]
      },
      enterprise: {
        name: 'Корпоративный',
        price: 'По запросу',
        description: 'Для крупных организаций с особыми требованиями',
        features: [
          'Неограниченно ИИ-агентов',
          'Неограниченно минут',
          'Индивидуальная аналитика',
          'Выделенная поддержка',
          'Персонализированные голоса',
          'Полный доступ к API',
          'Гарантия SLA',
          'Локальное размещение'
        ]
      }
    }
  },

  // Contact Us Page
  contactUs: {
    title: 'Свяжитесь с нами',
    subtitle: 'Обратитесь к нашей команде',
    form: {
      name: 'Ваше имя',
      email: 'Email адрес',
      company: 'Название компании',
      phone: 'Номер телефона',
      subject: 'Тема',
      message: 'Ваше сообщение',
      submit: 'Отправить сообщение',
      sending: 'Отправка...',
      success: 'Сообщение успешно отправлено! Мы скоро с вами свяжемся.',
      error: 'Не удалось отправить сообщение. Пожалуйста, попробуйте снова.'
    },
    info: {
      title: 'Связаться',
      description: 'Есть вопросы? Мы будем рады услышать вас.',
      email: 'support@aiconneqtors.com',
      phone: '+1 (888) 123-4567',
      address: 'Сан-Франциско, Калифорния'
    }
  },

  // User Login Page
  userLogin: {
    title: 'Вход агента',
    subtitle: 'Войдите в панель агента',
    username: 'Имя пользователя',
    password: 'Пароль',
    signIn: 'Войти',
    signingIn: 'Вход...',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет аккаунта?',
    contactAdmin: 'Свяжитесь с администратором'
  },

  // Sign Up Page
  signUp: {
    title: 'Создайте аккаунт',
    subtitle: 'Начните бесплатную пробную версию сегодня',
    name: 'Полное имя',
    email: 'Email адрес',
    password: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
    company: 'Название компании',
    phone: 'Номер телефона',
    createAccount: 'Создать аккаунт',
    creating: 'Создание аккаунта...',
    haveAccount: 'Уже есть аккаунт?',
    signIn: 'Войти',
    terms: 'Регистрируясь, вы соглашаетесь с Условиями использования и Политикой конфиденциальности'
  },

  // Admin Login
  adminLogin: {
    title: 'Вход администратора',
    subtitle: 'Доступ к панели администрирования',
    username: 'Имя пользователя',
    password: 'Пароль',
    signIn: 'Войти',
    signingIn: 'Вход...'
  },

  // Integrations Page
  integrationsPage: {
    title: 'Интеграции',
    subtitle: 'Подключите AIConneqtors к вашим любимым инструментам',
    searchPlaceholder: 'Поиск интеграций...',
    categories: {
      all: 'Все',
      crm: 'CRM',
      communication: 'Коммуникации',
      analytics: 'Аналитика',
      automation: 'Автоматизация'
    },
    connectButton: 'Подключить',
    connectedBadge: 'Подключено',
    learnMore: 'Подробнее'
  },

  // Documentation Page
  documentation: {
    title: 'Документация',
    subtitle: 'Всё необходимое для начала работы с AIConneqtors',
    searchPlaceholder: 'Поиск в документации...',
    gettingStarted: 'Начало работы',
    apiReference: 'Справочник API',
    guides: 'Руководства',
    tutorials: 'Обучающие материалы',
    faq: 'Частые вопросы'
  },

  // Releases Page
  releases: {
    title: 'Примечания к выпускам',
    subtitle: 'Будьте в курсе последних функций и улучшений',
    version: 'Версия',
    date: 'Выпущено',
    newFeatures: 'Новые функции',
    improvements: 'Улучшения',
    bugFixes: 'Исправления ошибок'
  }
};

export default ru;
